export default __webpack_public_path__ + "assets/02n.f84acd63.svg";